// import PresentmentFilterForm from './NachFilterForm';
import FilteredPresentmentList from './FilteredPresentmentList';

interface Props {
  setReload?: () => void;
  reload?: boolean;
}
const NachSection = ({}: Props) => {
  const reload = true;
  const filter = {};
  return (
    <section>
      <FilteredPresentmentList reload={reload} filter={{ ...filter }} />
    </section>
  );
};

export default NachSection;
